export const LIST_MCU_PROJECT_SLA_CONFIGURATION_REQUEST =
  'LIST_MCU_PROJECT_SLA_CONFIGURATION_REQUEST'
export const LIST_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS =
  'LIST_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS'
export const LIST_MCU_PROJECT_SLA_CONFIGURATION_FAIL =
  'LIST_MCU_PROJECT_SLA_CONFIGURATION_FAIL'

export const DETAIL_MCU_PROJECT_SLA_CONFIGURATION_REQUEST =
  'DETAIL_MCU_PROJECT_SLA_CONFIGURATION_REQUEST'
export const DETAIL_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS =
  'DETAIL_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS'
export const DETAIL_MCU_PROJECT_SLA_CONFIGURATION_FAIL =
  'DETAIL_MCU_PROJECT_SLA_CONFIGURATION_FAIL'

export const CREATE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST =
  'CREATE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST'
export const CREATE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS =
  'CREATE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS'
export const CREATE_MCU_PROJECT_SLA_CONFIGURATION_FAIL =
  'CREATE_MCU_PROJECT_SLA_CONFIGURATION_FAIL'

export const UPDATE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST =
  'UPDATE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST'
export const UPDATE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS =
  'UPDATE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS'
export const UPDATE_MCU_PROJECT_SLA_CONFIGURATION_FAIL =
  'UPDATE_MCU_PROJECT_SLA_CONFIGURATION_FAIL'

export const DELETE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST =
  'DELETE_MCU_PROJECT_SLA_CONFIGURATION_REQUEST'
export const DELETE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS =
  'DELETE_MCU_PROJECT_SLA_CONFIGURATION_SUCCESS'
export const DELETE_MCU_PROJECT_SLA_CONFIGURATION_FAIL =
  'DELETE_MCU_PROJECT_SLA_CONFIGURATION_FAIL'
